import { Link } from 'react-router-dom';
import { momentCategories } from '@/mocks/moments';
import { navLinks, siteInfo } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  const footerCategories = momentCategories.filter((item) => item !== '全部').slice(0, 5);

  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-plant-line text-xl"></i>
              </span>
              <span className="font-heading text-2xl tracking-wide">{siteInfo.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">{siteInfo.slogan}</p>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              私拍吃瓜名场面与抓拍盘点，最新热门优先展示。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-lg text-background-50">站内导航</h3>
            <ul className="mt-4 space-y-3">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg text-background-50">热门分类</h3>
            <ul className="mt-4 space-y-3">
              {footerCategories.map((item) => (
                <li key={item}>
                  <Link
                    to={`/moments?category=${encodeURIComponent(item)}`}
                    className="text-sm text-background-200 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg text-background-50">联系与投稿</h3>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              发现值得记录的画面？把场景和时间点发给我们。
            </p>
            <a
              href={`mailto:${siteInfo.email}`}
              className="mt-3 inline-flex items-center gap-2 text-sm text-secondary-300 hover:text-secondary-200 transition-colors cursor-pointer"
            >
              <i className="ri-mail-line"></i>
              {siteInfo.email}
            </a>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            © {year} {siteInfo.name} · 内容整理与观看顺序说明
          </p>
          <p className="text-xs text-background-300">
            站内画面版权归原发布方所有，仅用于观看顺序整理
          </p>
        </div>
      </div>
    </footer>
  );
}